import { render, staticRenderFns } from "./FooterLetter.vue?vue&type=template&id=4c08b5e6&scoped=true&"
import script from "./FooterLetter.vue?vue&type=script&lang=js&"
export * from "./FooterLetter.vue?vue&type=script&lang=js&"
import style0 from "./FooterLetter.vue?vue&type=style&index=0&id=4c08b5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08b5e6",
  null
  
)

export default component.exports